import { ComponentPropsWithoutRef, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input, InputProps, validateEmail } from '../../UI';
import { PersonFormValues } from '../types';

type PersonEmailInputProps = Pick<InputProps, 'label'> &
  Pick<ComponentPropsWithoutRef<'input'>, 'required' | 'className'>;

export const PersonEmailInput: FC<PersonEmailInputProps> = ({ label, required, className }) => {
  const { t: tForm } = useTranslation('form');
  const {
    register,
    formState: { errors },
  } = useFormContext<PersonFormValues>();

  return (
    <Input
      {...register('emailAddress', {
        required,
        validate: (email) => validateEmail(email, required),
      })}
      inputProps={{
        type: 'email',
        placeholder: required ? tForm('general-required-placeholder') : '',
      }}
      label={label || tForm('person-email-input-label')}
      className={className}
      status={errors.emailAddress ? 'errored' : 'normal'}
    />
  );
};
